import { jsx as _jsx } from "react/jsx-runtime";
import { FlowNodeTypes } from 'components/powerFlowShared/components/types';
import { FlowNode, flowNodeColor, NodeTypeComponent, } from 'fable/flowEditor';
import ActionModal from '../modals/hidden';
export class HideWidgetNode extends NodeTypeComponent() {
    render() {
        return (_jsx(FlowNode, { color: HideWidgetNode.color, icon: HideWidgetNode.icon, label: HideWidgetNode.label }));
    }
}
HideWidgetNode.icon = 'arrow-down';
HideWidgetNode.label = 'Hide Widget';
HideWidgetNode.color = flowNodeColor.red;
HideWidgetNode.ActionModal = ActionModal;
HideWidgetNode.actionTrigger = { type: FlowNodeTypes.HIDDEN };
HideWidgetNode.updateConnection = (node) => node;
